export interface PricesPassThroughParams {
  skipCache: string
  debug: string
  isLoadTest: string
}

export const pricesPassThroughParams = [
  'skipCache',
  'debug',
  'isLoadTest',
] as (keyof PricesPassThroughParams)[]
